
import { ActiveObject } from '../../Container';

export class PropMechanics extends ActiveObject {

    // @resolve(Service) service!: Service;

    public start(): void {
        // this.burden(
        // );
    }
}
